import { useEffect } from 'react';

import type { Receiver } from '../../../generated-types';
import useFormContext from './useFormContext';

export default (receiver: Receiver) => {
    const { handleChange } = useFormContext();
    useEffect(() => {
        handleChange({ type: 'account-name', payload: receiver.name });
        handleChange({ type: 'account-number', payload: receiver.accountNumber.value });
    }, [receiver, handleChange]);
};
